/**
 * postMessage protocol constants for iframe handshakes (checkout + wallet).
 *
 * Origin pinning is enforced at every receiver: events from origins other
 * than the configured checkout origin (default
 * ``https://checkout.lumiari.ai``) MUST be ignored.
 */

export const DEFAULT_CHECKOUT_ORIGIN = 'https://checkout.lumiari.ai';

// --- Checkout iframe protocol -----------------------------------------

/** iframe → widget: iframe finished bootstrapping and is ready to receive PREFILL. */
export const CHECKOUT_READY = 'CHECKOUT_READY';

/** widget → iframe: send pre-fill data (shopper token, customer email/name). */
export const PREFILL = 'PREFILL';

/** iframe → widget: open an external URL (e.g. provider 3DS). */
export const OPEN_PAYMENT_URL = 'OPEN_PAYMENT_URL';

/** iframe → widget: payment completed; widget should close iframe + render order_status. */
export const CHECKOUT_COMPLETE = 'CHECKOUT_COMPLETE';

/** iframe → widget: non-terminal payment status update while checkout stays open. */
export const CHECKOUT_STATUS = 'CHECKOUT_STATUS';

/** iframe → widget: user closed the checkout sheet. */
export const CHECKOUT_CLOSE = 'CHECKOUT_CLOSE';

// --- Wallet (add-card) iframe protocol --------------------------------

/** iframe → widget: wallet iframe is ready. */
export const WALLET_READY = 'WALLET_READY';

/** widget → iframe: pre-fill wallet data (org/provider/public_key). */
export const WALLET_PREFILL = 'WALLET_PREFILL';

/** iframe → widget: card saved successfully. */
export const CARD_SAVED = 'CARD_SAVED';

/** iframe → widget: error saving card. */
export const CARD_ERROR = 'CARD_ERROR';

/** iframe → widget: wallet sheet closed. */
export const WALLET_CLOSE = 'WALLET_CLOSE';

export type PostMessagePayload =
  | { type: typeof CHECKOUT_READY }
  | { type: typeof PREFILL; data?: Record<string, any> }
  | { type: typeof OPEN_PAYMENT_URL; url: string }
  | { type: typeof CHECKOUT_COMPLETE; order?: Record<string, any> }
  | { type: typeof CHECKOUT_STATUS; order?: Record<string, any>; status?: string }
  | { type: typeof CHECKOUT_CLOSE }
  | { type: typeof WALLET_READY }
  | { type: typeof WALLET_PREFILL; data?: Record<string, any> }
  | { type: typeof CARD_SAVED; card?: Record<string, any> }
  | { type: typeof CARD_ERROR; error?: string }
  | { type: typeof WALLET_CLOSE };
